import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "container-fix-padding" }
const _hoisted_2 = { class: "d-flex" }
const _hoisted_3 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_4 = { class: "d-flex align-items-center" }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "d-flex justify-end" }
const _hoisted_7 = { class: "mr-4" }
const _hoisted_8 = { class: "fw-bold mb-0" }
const _hoisted_9 = { class: "text-secondary small mb-0" }
const _hoisted_10 = { class: "table-responsive-wrapper" }
const _hoisted_11 = { class: "payment-table bg-white border-default py-1 mt-2" }
const _hoisted_12 = {
  key: 0,
  class: "d-flex px-4"
}
const _hoisted_13 = { class: "table-col col-date p-1" }
const _hoisted_14 = { class: "table-col col-status p-1" }
const _hoisted_15 = { class: "table-col col-action p-1" }
const _hoisted_16 = { key: 1 }
const _hoisted_17 = { key: 2 }
const _hoisted_18 = {
  key: 2,
  class: "d-flex justify-center align-center pa-8",
  style: {"min-height":"200px"}
}

import { ref, computed, watch, onMounted } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { checkMobile, readJsonResponse } from '../../utils/utils'
import Subscription, {
  StripeInvoice,
  StripeUpcomingInvoice,
  SubscriptionInvoice
} from '../../../api/v2/models/subscription'
import SubscriptionForm from '../../../api/v2/forms/subscription'
import { subscriptionState } from '../../stores/subscription'
import { userState } from '../../stores/user'
import { headerState } from '../../stores/header'
import { footerState } from '../../stores/footer'
import SubscriptionComponent from '../atoms_molecules/Subscription.vue'
import StripeInvoiceComponent from '../atoms_molecules/StripeInvoice.vue'
import StripeUpcomingInvoiceComponent from '../atoms_molecules/StripeUpcomingInvoice.vue'
import SubscriptionInvoiceComponent from '../atoms_molecules/SubscriptionInvoice.vue'
import StripeCardPayComponent from '../atoms_molecules/StripeCardPay.vue'
import StripeElementCardPayComponent from '../atoms_molecules/StripeElementCardPay.vue'
import CourseMy from '../atoms_molecules/CourseMy.vue'
import DialogDeleteSubscriptionConfirm from '../atoms_molecules/DialogDeleteSubscriptionConfirm.vue'
import { format } from 'date-fns'
import ChangePlan from '../pages/subscription/ChangePlan.vue'
import StripeToken from '../../../api/v2/models/stripe_token'
import { getQueryString } from '../../../../helpers/route-helper'

// Router

export default /*@__PURE__*/_defineComponent({
  __name: 'SubscriptionDetail',
  setup(__props) {

const route = useRoute()
const router = useRouter()

// Reactive state
const mobile = ref(false)
const cancelling = ref(false)
const tab = ref<1 | 0>(0)
const cardLast4 = ref<string>('')
const cardExpMonth = ref<number | null>(null)
const cardExpYear = ref<number | null>(null)
const stripeToken = ref<StripeToken | null>(null)
const subscription = ref<Subscription | null>(null)
const stripeUpcomingInvoice = ref<StripeUpcomingInvoice | null>(null)
const stripeInvoices = ref<StripeInvoice[]>([])
const subscriptionInvoices = ref<SubscriptionInvoice[]>([])
const membershipStatus = ref<string>('')
const downloadingReceiptId = ref<string>('')

// Breadcrumbs
const breadcrumbs = [
  {
    text: 'クラスルーム',
    disabled: false,
    exact: true,
    to: '/classroom/'
  },
  {
    text: '購入済み',
    disabled: false,
    exact: true,
    to: '/classroom/subscription'
  }
]

// Computed properties
const user = computed(() => {
  return userState.user
})

const isLoading = computed(() => {
  return subscriptionState.isLoading
})

const errorMessage = computed(() => {
  return subscriptionState.errorMessage
})

const tabQuery = computed((): string | null => {
  return getQueryString(route.query, 'tab')
})

const lastSubscriptionInvoice = computed(() => {
  return subscriptionInvoices.value[0]
})

// Watchers
watch(() => router, () => {
  const tabValue = tabQuery.value
  if (tabValue) {
    tab.value = tabValue == 'HISTORY' ? 0 : 1
  }
}, { immediate: true })

watch(tab, () => {
  router.push({
    query: {
      tab: tab.value == 0 ? 'HISTORY' : 'CHANGE_PLAN'
    }
  })
})

watch(subscription, () => {
  if (subscription.value) {
    // Update other fields as needed
  }
})

// Methods
const getSubscription = async () => {
  const response = await subscriptionState.getSubscription(route.params.subscriptionId as any)
  if (response) {
    subscription.value = response.subscription
    if (subscription.value.planChangeBlocked) tab.value = 0
    stripeUpcomingInvoice.value = response.stripeUpcomingInvoice
    stripeInvoices.value = response.stripeInvoices
    subscriptionInvoices.value = response.subscriptionInvoices
  }
}

const shouldHideCancel = computed((): boolean => {
  if (!subscription.value) return false
  return subscription.value.hideCancelButton
})

// After 3DS confirms the new card, ask the backend to update
// Stripe::Subscription.default_payment_method (set_payment_method only
// touches the Customer-level default).
const onPaymentMethodCartSetup = async (paymentMethodId: string) => {
  if (!subscription.value || !paymentMethodId) return
  try {
    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content') || ''
    const response = await fetch(
      `/premium_services/${subscription.value.premiumServiceId}/subscriptions/save_payment_method`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          // See StripeElementCardPay.vue: without Accept the request is treated
          // as HTML and errors come back as an HTML page instead of JSON.
          'Accept': 'application/json',
          'X-CSRF-Token': csrfToken
        },
        body: JSON.stringify({
          premium_service_id: subscription.value.premiumServiceId,
          subscription_id: subscription.value.id,
          payment_method: paymentMethodId
        })
      }
    )
    const data = await readJsonResponse(response)
    if (!data) {
      throw new Error(`カード情報の保存に失敗しました (${response.status})`)
    }
    if (!data.success) {
      throw new Error(data.error || 'カード情報の保存に失敗しました')
    }
    await getSubscription()
  } catch (error) {
    console.error('save_payment_method failed:', error)
    alert(error instanceof Error ? error.message : 'カード情報の保存に失敗しました')
  }
}

const onPay = async (tokenId: string) => {
  const subscriptionForm = new SubscriptionForm()
  subscriptionForm.subscriptionId = subscription.value!.id
  subscriptionForm.token = tokenId
  subscriptionForm.email = user.value!.email
  await subscriptionState.updateSubscription({
    subscriptionForm
  })
  getSubscription()
  userState.getUser()
}

const onCancelPay = async (message: string = '') => {
  cancelling.value = true
  try {
    await subscriptionState.cancelSubscription({
      subscriptionId: subscription.value!.id,
      message
    })
    await getSubscription()
  } finally {
    cancelling.value = false
  }
}

const dateFormat = (date: Date) => {
  return format(date, 'YYYY/MM/DD')
}

const beforeOneDay = (date: Date) => {
  return new Date(date.getTime() + 24 * 60 * 60 * 1000)
}

const openNewTab = (url: string): void => {
  window.open(url, '_blank')
}

const getMembershipStatus = (invoices: StripeInvoice[]) => {
  let flagMembershipFeePaid = false
  invoices.forEach((stripeInvoice) => {
    if (stripeInvoice.amountPaid > 0) {
      let membershipFeeLine: any = stripeInvoice.lines.data.find((line: any) => line.description?.includes('Membership Fee'))
      if (membershipFeeLine) {
        flagMembershipFeePaid = true
      }
    }
  })

  if (flagMembershipFeePaid) {
    return 'paid'
  } else {
    return ''
  }
}

const handlePaymentComplete = (paymentIntentId: string) => {
  console.log('Payment successful with payment intent:', paymentIntentId)
  // Use the existing onPay method with the payment intent ID
  // onPay(paymentIntentId);
}

const cardNumber = () => {
  if (cardLast4.value) {
    return `**** **** **** ${cardLast4.value}`
  } else if (stripeToken.value) {
    return `**** **** **** ${stripeToken.value.last4}`
  }
  const cardNum = subscription.value && subscription.value.stripeCustomerDefaultCardNumber
  return cardNum ? `**** **** **** ${cardNum}` : 'カード情報なし'
}

const cardDate = () => {
  if (cardExpMonth.value && cardExpYear.value) {
    const month = String(cardExpMonth.value).padStart(2, '0')
    const year = String(cardExpYear.value)
    return `${month}/${year}`
  } else if (stripeToken.value) {
    return `${stripeToken.value.expMonth}/${stripeToken.value.expYear}`
  }
  const cardD = subscription.value && subscription.value.stripeCustomerDefaultCardExpiredAt
  return cardD || '-'
}

const updateCardDetails = (cardDetails: any) => {
  cardLast4.value = cardDetails.last4
  cardExpMonth.value = cardDetails.exp_month
  cardExpYear.value = cardDetails.exp_year
}

const downloadReceipt = (invoiceId: string): Promise<void> =>
  fetchReceipt(invoiceId, `invoice_id=${invoiceId}`)

// 買い切りは Stripe の Invoice が無いので、支払い記録の id で領収書を作る
const downloadSubscriptionInvoiceReceipt = (subscriptionInvoiceId: string): Promise<void> =>
  fetchReceipt(subscriptionInvoiceId, `subscription_invoice_id=${subscriptionInvoiceId}`)

const fetchReceipt = async (invoiceId: string, query: string): Promise<void> => {
  downloadingReceiptId.value = invoiceId
  try {
    const subscriptionId = subscription.value?.id
    const receiptUrl = `/api/v2/subscriptions/${subscriptionId}/receipt?${query}`
    const response = await fetch(receiptUrl)
    if (!response.ok) throw new Error('Download failed')
    const blob = await response.blob()
    const url = window.URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.href = url
    link.download = `receipt_${invoiceId}.pdf`
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    window.URL.revokeObjectURL(url)
  } catch (e) {
    console.error('Receipt download error:', e)
  } finally {
    downloadingReceiptId.value = ''
  }
}

// Lifecycle
onMounted(async () => {
  mobile.value = checkMobile()
  headerState.setTitle('購入済み')
  footerState.setFooterDefault()
  await getSubscription()
  membershipStatus.value = getMembershipStatus(stripeInvoices.value)
})

return (_ctx: any,_cache: any) => {
  const _component_AppBreadcrumb = _resolveComponent("AppBreadcrumb")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_tabs = _resolveComponent("v-tabs")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_tabs_window_item = _resolveComponent("v-tabs-window-item")!
  const _component_v_tabs_window = _resolveComponent("v-tabs-window")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_col = _resolveComponent("v-col")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_AppBreadcrumb, { items: [
      { text: 'クラスルーム', to: '/classroom/' },
      { text: '購入済み', to: '/classroom/subscription' },
      { text: '詳細' }
    ] }),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_v_col, {
        lg: "12",
        class: "p-4 bg-white"
      }, {
        default: _withCtx(() => [
          (errorMessage.value)
            ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(errorMessage.value), 1 /* TEXT */))
            : _createCommentVNode("v-if", true),
          (subscription.value)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createVNode(SubscriptionComponent, {
                  subscription: subscription.value,
                  stripeUpcomingInvoice: stripeUpcomingInvoice.value
                }, null, 8 /* PROPS */, ["subscription", "stripeUpcomingInvoice"]),
                (subscription.value && subscription.value.hasCoupon)
                  ? (_openBlock(), _createBlock(_component_v_alert, {
                      key: 0,
                      density: "compact",
                      type: "info",
                      class: "mt-3",
                      variant: "outlined"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_4, [
                          _cache[3] || (_cache[3] = _createElementVNode("strong", { class: "mr-2" }, "クーポン適用:", -1 /* CACHED */)),
                          _createVNode(_component_v_chip, {
                            color: "green",
                            size: "small",
                            label: "",
                            class: "text-white mr-2"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(subscription.value.couponCode), 1 /* TEXT */)
                            ]),
                            _: 1 /* STABLE */
                          }),
                          _createElementVNode("span", null, _toDisplayString((subscription.value.discountBeforePrice || 0).toLocaleString()) + "円 → " + _toDisplayString((subscription.value.discountAfterPrice || 0).toLocaleString()) + "円 （-" + _toDisplayString((subscription.value.discountAmount || 0).toLocaleString()) + "円 割引） ", 1 /* TEXT */)
                        ])
                      ]),
                      _: 1 /* STABLE */
                    }))
                  : _createCommentVNode("v-if", true),
                (subscription.value.planChangeBlocked)
                  ? (_openBlock(), _createBlock(_component_v_alert, {
                      key: 1,
                      type: "info",
                      variant: "tonal",
                      class: "mb-4"
                    }, {
                      default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                        _createTextVNode(" 休会・無料期間の予約中、実行中、再開待ちはプラン変更できません。カード情報は更新できます。 ", -1 /* CACHED */)
                      ]))]),
                      _: 1 /* STABLE */
                    }))
                  : _createCommentVNode("v-if", true),
                _createVNode(_component_v_tabs, {
                  modelValue: tab.value,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((tab).value = $event))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_tab, { value: 0 }, {
                      default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                        _createTextVNode("支払い", -1 /* CACHED */)
                      ]))]),
                      _: 1 /* STABLE */
                    }),
                    (stripeUpcomingInvoice.value && !subscription.value.edbaseInstallment && !subscription.value.planChangeBlocked)
                      ? (_openBlock(), _createBlock(_component_v_tab, {
                          key: 0,
                          value: 1
                        }, {
                          default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                            _createTextVNode("プラン変更", -1 /* CACHED */)
                          ]))]),
                          _: 1 /* STABLE */
                        }))
                      : _createCommentVNode("v-if", true)
                  ]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["modelValue"]),
                _createVNode(_component_v_divider, { class: "mt-2" }),
                _createVNode(_component_v_tabs_window, {
                  modelValue: tab.value,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((tab).value = $event))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_tabs_window_item, { value: 0 }, {
                      default: _withCtx(() => [
                        (stripeInvoices.value.some((stripeInvoice) => stripeInvoice.status === 'open'))
                          ? (_openBlock(), _createBlock(_component_v_alert, {
                              key: 0,
                              density: "compact",
                              border: "start",
                              type: "warning"
                            }, {
                              default: _withCtx(() => [
                                _cache[8] || (_cache[8] = _createTextVNode(" あなたには未完了の取引があります。 ", -1 /* CACHED */)),
                                _createVNode(_component_v_btn, {
                                  color: "primary",
                                  dark: "",
                                  onClick: _cache[1] || (_cache[1] = ($event: any) => (openNewTab(stripeInvoices.value.find((stripeInvoice) => stripeInvoice.status === 'open').hostedInvoiceUrl)))
                                }, {
                                  default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                                    _createTextVNode(" 支払いを確定する ", -1 /* CACHED */)
                                  ]))]),
                                  _: 1 /* STABLE */
                                })
                              ]),
                              _: 1 /* STABLE */
                            }))
                          : _createCommentVNode("v-if", true),
                        (!subscription.value.isStoped)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                              _createElementVNode("div", _hoisted_6, [
                                _createElementVNode("div", _hoisted_7, [
                                  _createElementVNode("p", _hoisted_8, _toDisplayString(cardNumber()), 1 /* TEXT */),
                                  _createElementVNode("p", _hoisted_9, "有効期限: " + _toDisplayString(cardDate()), 1 /* TEXT */)
                                ]),
                                (user.value)
                                  ? (_openBlock(), _createBlock(StripeElementCardPayComponent, {
                                      key: 0,
                                      title: user.value.currentSchoolName,
                                      description: 'カードを変更する',
                                      mail: user.value.email,
                                      user_id: String(user.value.id),
                                      premiumServiceId: String(subscription.value.premiumServiceId),
                                      changeFromSubscriptionId: String(subscription.value.id),
                                      type_change: 'not_default',
                                      onCardDetails: updateCardDetails,
                                      onPaymentMethodCartSetup: onPaymentMethodCartSetup
                                    }, null, 8 /* PROPS */, ["title", "mail", "user_id", "premiumServiceId", "changeFromSubscriptionId"]))
                                  : _createCommentVNode("v-if", true)
                              ])
                            ]))
                          : _createCommentVNode("v-if", true),
                        _createElementVNode("div", _hoisted_10, [
                          _createElementVNode("div", _hoisted_11, [
                            _cache[11] || (_cache[11] = _createElementVNode("div", { class: "d-flex px-4 table-header" }, [
                              _createElementVNode("div", { class: "table-col col-date p-1" }, " お支払い日時 "),
                              _createElementVNode("div", { class: "table-col col-amount p-1" }, " お支払い金額 "),
                              _createElementVNode("div", { class: "table-col col-status p-1" }, " ステータス "),
                              _createElementVNode("div", { class: "table-col col-action p-1" })
                            ], -1 /* CACHED */)),
                            _createVNode(_component_v_divider, { class: "my-2" }),
                            (subscription.value && subscription.value.endDate)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                  _createElementVNode("div", _hoisted_13, _toDisplayString(dateFormat(beforeOneDay(subscription.value.endDate))), 1 /* TEXT */),
                                  _cache[10] || (_cache[10] = _createElementVNode("div", { class: "table-col col-amount p-1" }, "0円", -1 /* CACHED */)),
                                  _createElementVNode("div", _hoisted_14, [
                                    _createVNode(_component_v_chip, {
                                      class: "me-2 text-white",
                                      color: "red",
                                      size: "small",
                                      label: ""
                                    }, {
                                      default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                                        _createTextVNode(" キャンセル済み ", -1 /* CACHED */)
                                      ]))]),
                                      _: 1 /* STABLE */
                                    })
                                  ]),
                                  _createElementVNode("div", _hoisted_15, _toDisplayString(dateFormat(subscription.value.endDate)) + " まで有効 ", 1 /* TEXT */)
                                ]))
                              : _createCommentVNode("v-if", true),
                            (subscription.value && (subscription.value.isEachMonth || subscription.value.edbaseInstallment))
                              ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                                  (stripeUpcomingInvoice.value)
                                    ? (_openBlock(), _createBlock(StripeUpcomingInvoiceComponent, {
                                        key: 0,
                                        stripeUpcomingInvoice: stripeUpcomingInvoice.value,
                                        hideCancel: shouldHideCancel.value,
                                        loading: cancelling.value,
                                        onCancel: onCancelPay
                                      }, null, 8 /* PROPS */, ["stripeUpcomingInvoice", "hideCancel", "loading"]))
                                    : _createCommentVNode("v-if", true),
                                  _createVNode(_component_v_divider, { class: "my-2" }),
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(stripeInvoices.value, (stripeInvoice, index) => {
                                    return (_openBlock(), _createBlock(StripeInvoiceComponent, {
                                      class: "mt-1",
                                      key: index,
                                      stripeInvoice: stripeInvoice,
                                      "show-membership-fee": subscription.value.needMembershipFee,
                                      "membership-fee": subscription.value.membershipFee,
                                      "membership-fee-paid-at": subscription.value.membershipFeePaidAt ? String(subscription.value.membershipFeePaidAt) : '',
                                      "membership-fee-charge-at": subscription.value.membershipFeeChargeAt ? String(subscription.value.membershipFeeChargeAt) : '',
                                      "membership-fee-charge-failed": subscription.value.membershipFeeChargeFailed,
                                      "membership-fee-charge-failed-message": subscription.value.membershipFeeChargeFailedMessage,
                                      "is-last-invoice": index === stripeInvoices.value.length - 1,
                                      "need-membership-fee": subscription.value.needMembershipFee,
                                      stripeUpcomingInvoice: stripeUpcomingInvoice.value,
                                      "membership-status": membershipStatus.value,
                                      "downloading-receipt-id": downloadingReceiptId.value,
                                      onDownloadReceipt: downloadReceipt
                                    }, null, 8 /* PROPS */, ["stripeInvoice", "show-membership-fee", "membership-fee", "membership-fee-paid-at", "membership-fee-charge-at", "membership-fee-charge-failed", "membership-fee-charge-failed-message", "is-last-invoice", "need-membership-fee", "stripeUpcomingInvoice", "membership-status", "downloading-receipt-id"]))
                                  }), 128 /* KEYED_FRAGMENT */))
                                ]))
                              : (_openBlock(), _createElementBlock("div", _hoisted_17, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(subscriptionInvoices.value, (subscriptionInvoice, index) => {
                                    return (_openBlock(), _createBlock(SubscriptionInvoiceComponent, {
                                      class: "mt-1",
                                      key: index,
                                      subscriptionInvoice: subscriptionInvoice,
                                      "downloading-receipt-id": downloadingReceiptId.value,
                                      onDownloadReceipt: downloadSubscriptionInvoiceReceipt
                                    }, null, 8 /* PROPS */, ["subscriptionInvoice", "downloading-receipt-id"]))
                                  }), 128 /* KEYED_FRAGMENT */))
                                ]))
                          ])
                        ])
                      ]),
                      _: 1 /* STABLE */
                    }),
                    (!subscription.value.planChangeBlocked)
                      ? (_openBlock(), _createBlock(_component_v_tabs_window_item, {
                          key: 0,
                          value: 1
                        }, {
                          default: _withCtx(() => [
                            _createVNode(ChangePlan, { subscription: subscription.value }, null, 8 /* PROPS */, ["subscription"])
                          ]),
                          _: 1 /* STABLE */
                        }))
                      : _createCommentVNode("v-if", true)
                  ]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["modelValue"])
              ], 64 /* STABLE_FRAGMENT */))
            : (_openBlock(), _createElementBlock("div", _hoisted_18, [
                _createVNode(_component_v_progress_circular, {
                  indeterminate: "",
                  color: "primary",
                  size: "48"
                })
              ]))
        ]),
        _: 1 /* STABLE */
      })
    ])
  ]))
}
}

})